import browser from '@motionelements/core/src/store/modules/browser.js';

export default {
  namespaced: true,
  state: () => browser.state,
  getters: {
    ...browser.getters,
    isMobile: (state) => state.window.width < 1200,
  },
  actions: browser.actions,
  mutations: browser.mutations,
};
